import React from "react";
import { TEST_IDS } from "@/lib/testIds";
import { PHOTOS } from "@/lib/links";

const milestones = [
  "Infinite Banking Practitioner",
  "Nelson Nash Institute training",
  "Active in IBC practitioner communities",
  "Ongoing conferences & professional development",
  "Continuous study of financial systems & long-term thinking",
];

export const Credibility = () => {
  return (
    <section
      id="learning-credibility"
      data-testid={TEST_IDS.credibility.section}
      className="bg-paperdeep py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-7">Always a Student</p>
            <h2
              className="font-serif text-nearblack leading-[1.06] text-balance"
              style={{ fontSize: "clamp(2rem, 3.6vw, 3.4rem)", fontWeight: 400 }}
            >
              Committed to{" "}
              <em className="italic text-camel">ongoing learning</em>.
            </h2>
            <p className="mt-7 text-nearblack/80 text-[16px] md:text-[17px] leading-[1.85] font-light max-w-md">
              The best financial systems are built on principles that stand
              the test of time. I regularly invest in continuing education,
              practitioner training, conferences, and professional communities
              so I can better serve the individuals and families I work with.
            </p>

            <ul className="mt-10 space-y-4">
              {milestones.map((m) => (
                <li
                  key={m}
                  className="flex items-start gap-4 border-t border-camel/30 pt-4"
                >
                  <span className="font-serif italic text-camel text-lg leading-none mt-0.5">
                    —
                  </span>
                  <span className="text-[14px] md:text-[15px] text-nearblack/85 leading-relaxed">
                    {m}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-12 gap-4 md:gap-5">
              <figure className="col-span-12 md:col-span-7">
                <div className="aspect-[16/10] overflow-hidden bg-paper border border-paper/40">
                  <img
                    src={PHOTOS.credibility.stage}
                    alt="Liz with fellow practitioners on stage at an IBC conference"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <figcaption
                  className="mt-3 text-stonegrey"
                  style={{ fontSize: "0.62rem", letterSpacing: "0.32em", textTransform: "uppercase", fontWeight: 500 }}
                >
                  Practitioner conference panel
                </figcaption>
              </figure>

              <figure className="col-span-6 md:col-span-5">
                <div className="aspect-[3/4] overflow-hidden bg-paper border border-paper/40">
                  <img
                    src={PHOTOS.lizOutdoor}
                    alt="Portrait of Liz Dirocco"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <figcaption
                  className="mt-3 text-stonegrey"
                  style={{ fontSize: "0.62rem", letterSpacing: "0.32em", textTransform: "uppercase", fontWeight: 500 }}
                >
                  In her element
                </figcaption>
              </figure>

              <figure className="col-span-6 md:col-span-4">
                <div className="aspect-[3/4] overflow-hidden bg-paper border border-paper/40">
                  <img
                    src={PHOTOS.credibility.book}
                    alt="Liz studying financial education materials"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <figcaption
                  className="mt-3 text-stonegrey"
                  style={{ fontSize: "0.62rem", letterSpacing: "0.32em", textTransform: "uppercase", fontWeight: 500 }}
                >
                  Always reading
                </figcaption>
              </figure>

              <figure className="col-span-6 md:col-span-8">
                <div className="aspect-[16/10] overflow-hidden bg-paper border border-paper/40">
                  <img
                    src={PHOTOS.credibility.conversation}
                    alt="Liz in conversation with a fellow practitioner"
                    loading="lazy"
                    style={{ objectPosition: "center top" }}
                    className="w-full h-full object-cover"
                  />
                </div>
                <figcaption
                  className="mt-3 text-stonegrey"
                  style={{ fontSize: "0.62rem", letterSpacing: "0.32em", textTransform: "uppercase", fontWeight: 500 }}
                >
                  Professional community
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
